import request from "@/core/services/request";

export function getInstance(instance, params) {
  return request({
    url: "/api/v1/instance/" + instance + "/",
    method: "get",
    params: params,
  });
}

export function postInstance(instance, data) {
  return request({
    url: "/api/v1/instance/" + instance + "/",
    method: "post",
    data: data,
  });
}

export function putInstance(instance, data) {
  return request({
    url: "/api/v1/instance/" + instance + "/",
    method: "put",
    data: data,
  });
}

export function deleteInstance(instance, data) {
  return request({
    url: "/api/v1/instance/" + instance + "/",
    method: "delete",
    data: data,
  });
}
